import React from 'react';
import { ButtonPrimaryDark } from '@americanexpress/dls-react';

import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import LiteralsService from 'src/services/literals/LiteralsService';

import colors from 'src/styles/colors.module.scss';
import { DLSSize } from 'src/types/dls-size.enum';
import styles from './highYieldSavingsCallout.module.scss';
import worldServiceTilePng from 'src/assets/png/worldservice-tile-deepblue.png';
import Selectors from 'src/utils/selectors';

export default function HighYieldSavingsCallout(): JSX.Element {
    return (
        <div
            className={styles.highYieldSavingsCalloutContainer}
            style={{ backgroundImage: `url(${worldServiceTilePng})` }}
        >
            <Typography variant={TypographyVariants.HEADING_S} className={colors.textLight}>
                {LiteralsService.getLiteral('Callout.HighYieldSavings.header')}
            </Typography>
            <Typography component="p" variant={TypographyVariants.BODY} className={colors.textLight}>
                {LiteralsService.getLiteral('Callout.HighYieldSavings.description')}
            </Typography>
            {/* TODO: correct URL needs to be placed here */}
            <ButtonPrimaryDark
                data-cy={Selectors.PlanAhead.HIGH_YIELD_SAVINGS_LINK}
                size={DLSSize.SMALL}
                onClick={() => {}}
            >
                {LiteralsService.getLiteral('Callout.HighYieldSavings.learnMore')}
            </ButtonPrimaryDark>
        </div>
    );
}
